export const HOME_URL = '/';
export const JOBS_URL = '/jobs';
export const CRITERIA_URL = '/criteria';
export const CONTACT_URL = '/contact';
export const FAQ_APP_URL = '/faq-app';
export const FAQ_EMP_URL = '/faq-emp';
export const SUCCESS_URL = '/contact/success';
